exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".floating-action-bar{position:fixed;bottom:0;width:100%;z-index:10;background-color:#fff;border-top:1px solid #ededed}.floating-action-bar.dark-background{background-color:#333}.floating-action-bar.boxShadow{box-shadow:0 -2px 4px -1px #ddd}.floating-action-bar .with-padding{padding:8px}.floating-action-bar.animated{transition:bottom .5s ease-in-out;bottom:-100px}", ""]);

// exports
